import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import GoogleLogin from 'react-google-login';
import { useMutation } from '@apollo/client';
import { toast } from 'react-toastify';

import { CREATE_USER, SIGNUP_WITH_GOOGLE } from '../../http/apollo-queries';

import { Button, Loading } from '../../components/UI';

import { useSignUpContext } from './SignUpContext';
import { useAuth } from '../../context/Auth';
import { useModalContext } from '../../context/Modal';

import { trackEvent } from '../../helpers/analytics';
import { logger } from '../../helpers/logger';

const SignUpWithGoogle = () => {
  const navigate = useNavigate();
  const { signIn, refresh, refetch: refetchUser } = useAuth();
  const { state } = useSignUpContext();
  const { t, i18n } = useTranslation();
  const { dispatch: setModal, closeModal } = useModalContext();

  const [signupWithGoogle] = useMutation(SIGNUP_WITH_GOOGLE);
  const [createUser] = useMutation(CREATE_USER);

  const handleSuccess = (res: any) => {
    setModal({
      isFullScreenElement: true,
      className: 'bg-grey-90 bg-opacity-10',
      element: (
        <Loading
          className="w-32 h-16 m-auto text-primary"
          size="large"
          status
        />
      ),
    });

    const googleUser = res?.profileObj;
    const googleId = res?.googleId;
    const token = res?.tokenId;

    logger.log('GoogleAuth:googleId', googleId);

    signupWithGoogle({
      variables: {
        email: googleUser.email,
        googleId,
        token,
      },
    })
      .then((res: any) => {
        const { otpPassword } = res.data?.signupWithGoogle;
        return signIn(googleUser.email, otpPassword);
      })
      .then((res: any) => {
        return createUser({
          variables: {
            language: i18n.language.toUpperCase(),
            referralCode: state.referralCode,
          },
        });
      })
      .then(() => refresh())
      .then(() => refetchUser())
      .then(() => navigate('/choose-username'))
      .catch((err) => {
        logger.error(err);

        if (err.message === 'USER_ALREADY_REGISTERED') {
          toast.error(
            'User already registered, please use another email address!'
          );
        } else {
          toast.error(t('signUp.form.signupWithGoogleError.' + err.message));
        }
      })
      .finally(closeModal);
  };

  const handleClick = (onClick) => {
    trackEvent('signup_google_initiated');
    return onClick();
  };

  const handleFailure = async (error: any) => {
    logger.error(error);
    //toast.error(t('signUp.form.signupWithGoogleError.' + error.message));
  };

  return (
    <GoogleLogin
      clientId={process.env.REACT_APP_GOOGLE_ID!}
      render={(renderProps) => (
        <Button
          type="button"
          onClick={() => handleClick(renderProps.onClick)}
          buttonClass="border border-grey-30 w-full p-2 font-semibold text-black dark:text-white mt-4"
        >
          {t('signUp.form.signupWithGoogle')}
          <img alt="google" src="/google.svg" className="ml-auto" />
        </Button>
      )}
      onSuccess={handleSuccess}
      onFailure={handleFailure}
      isSignedIn={false}
      cookiePolicy={'single_host_origin'}
    />
  );
};
export default SignUpWithGoogle;
